import { Card, CardContent, Link, Stack, Typography, IconButton, Tooltip } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { WalletModel } from 'src/common/api'
import { QCADIcon } from 'src/common/assets'
import { formatNumber, trimId } from 'src/common/helpers'
import { EXPLORER, WALLET_ICON } from 'src/common/static'
import DeleteIcon from '@mui/icons-material/Delete'
import * as S from './styles'

interface WalletCardProps {
  wallet: WalletModel & { walletType?: string }
  onDelete?: (walletId: string) => void
}

const WalletCard: React.FC<WalletCardProps> = ({ wallet, onDelete }: WalletCardProps) => {
  const { id, name, address, balance, chain, walletType } = wallet
  const Icon = WALLET_ICON[chain]
  const isTreasuryWallet = walletType === 'TREASURY'

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (onDelete && id) {
      onDelete(id)
    }
  }

  return (
    <Box mt="24px" key={id} display="flex" justifyContent="center">
      <Card elevation={3}>
        <CardContent sx={{ p: '20px' }}>
          <Stack direction="row" alignItems="center" mb={3} spacing={1.5}>
            <Icon fontSize="large" />
            <Typography variant="h6" width="215px" noWrap>
              {name}
            </Typography>
            {isTreasuryWallet && onDelete && (
              <Tooltip title="Delete Wallet" arrow>
                <IconButton
                  size="small"
                  onClick={handleDeleteClick}
                  sx={{
                    ml: 'auto',
                    color: 'error.main',
                    '&:hover': {
                      backgroundColor: 'error.light',
                      color: 'error.dark'
                    }
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>

          <Stack spacing={2} mb={2.5}>
            <Stack direction="row">
              <QCADIcon />
              <Typography flexGrow={1} ml={2}>
                QCAD
              </Typography>
              <Typography>{formatNumber(balance?.qcad ?? balance?.qcad_xlm ?? 0)}</Typography>
            </Stack>
          </Stack>

          <Stack direction="row" alignItems="center">
            <S.CircleIcon connected={true} />
            <Typography ml={1} flexGrow={1} variant="body2">
              Connected
            </Typography>
            <Link
              component="a"
              target="_blank"
              rel="noopener"
              href={`${EXPLORER[chain]}/address/${address}`}
              color="inherit"
              variant="body2"
            >
              {trimId(address)}
            </Link>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}

export default WalletCard
